import React from 'react';
import PropTypes from 'prop-types';
import { FILE_STATES } from '../../../constants';
import FileItem from '../FileItem';

import styles from '../Upload.module.scss';

const Files = ({ files, fileStates, Icon, errors, handleRemoveFile }) => {
  if (!files.length) {
    return <></>;
  }

  return (
    <div className={styles.fileContainer}>
      {files.map((f) => (
        <FileItem
          key={f.src}
          errors={errors}
          handleRemoveFile={handleRemoveFile}
          isPending={fileStates[f.src] === FILE_STATES.PENDING}
          isUploaded={fileStates[f.src] === FILE_STATES.UPLOADED}
          isImage={f.isImage}
          name={f.meta.name}
          Icon={Icon}
          src={f.src}
        />
      ))}
    </div>
  );
};

Files.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      isImage: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  fileStates: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  Icon: PropTypes.elementType.isRequired,
  handleRemoveFile: PropTypes.func.isRequired,
};

export default Files;
